import {
  FETCHADVERTISEMENTS,
  FETCHADVERTISEMENTS_SUCCESS,
  FETCHCOUPONS,
  FETCHCOUPONS_SUCCESS,
  FETCHVOTINGS,
  FETCHVOTINGS_SUCCESS,
  FETCHPOLLINGS,
  FETCHPOLLINGS_SUCCESS,
  FETCHDEEPLINKS,
  FETCHDEEPLINKS_SUCCESS,
  FETCHADVERTISEMENT,
  FETCHADVERTISEMENT_SUCCESS,
  FETCHCOUPON,
  FETCHCOUPON_SUCCESS,
  FETCHVOTING,
  FETCHVOTING_SUCCESS,
  FETCHPOLLING,
  FETCHPOLLING_SUCCESS,
  FETCHDEEPLINK,
  FETCHDEEPLINK_SUCCESS,
  FETCHEVENTS,
  FETCHEVENTS_SUCCESS,
  CREATEEVENT,
  CREATEEVENT_SUCCESS,
  UPDATEEVENT,
  UPDATEEVENT_SUCCESS,
  DELETEEVENT,
  DELETEEVENT_SUCCESS,
  FETCHPOLLINGQUESTIONS,
  FETCHPOLLINGQUESTIONS_SUCCESS,
  FETCHVOTINGQUESTIONS,
  FETCHVOTINGQUESTIONS_SUCCESS,
  FETCHPOLLINGANSWERS,
  FETCHPOLLINGANSWERS_SUCCESS,
  FETCHVOTINGANSWERS,
  FETCHVOTINGANSWERS_SUCCESS,
  CREATEADVERTISEMENT,
  CREATEADVERTISEMENT_SUCCESS,
  UPDATEADVERTISEMENT,
  UPDATEADVERTISEMENT_SUCCESS,
  DELETEADVERTISEMENT,
  DELETEADVERTISEMENT_SUCCESS,
  CREATECOUPON,
  CREATECOUPON_SUCCESS,
  UPDATECOUPON,
  UPDATECOUPON_SUCCESS,
  DELETECOUPON,
  DELETECOUPON_SUCCESS,
  CREATEVOTING,
  CREATEVOTING_SUCCESS,
  UPDATEVOTING,
  UPDATEVOTING_SUCCESS,
  DELETEVOTING,
  DELETEVOTING_SUCCESS,
  CREATEPOLLING,
  CREATEPOLLING_SUCCESS,
  UPDATEPOLLING,
  UPDATEPOLLING_SUCCESS,
  DELETEPOLLING,
  DELETEPOLLING_SUCCESS,
  CREATEDEEPLINK,
  CREATEDEEPLINK_SUCCESS,
  UPDATEDEEPLINK,
  UPDATEDEEPLINK_SUCCESS,
  DELETEDEEPLINK,
  DELETEDEEPLINK_SUCCESS
} from "constants/ActionTypes";

export const fetchAdvertisements = (applicationId) => {
  console.log('applicationId', applicationId);
  return {
    type: FETCHADVERTISEMENTS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchAdvertisementsSuccess = (applicationId, minisites) => {

  return {
    type: FETCHADVERTISEMENTS_SUCCESS,
    applicationId: applicationId,
    payload: minisites
  };
};

export const fetchCoupons = (applicationId) => {
  return {
    type: FETCHCOUPONS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchCouponsSuccess = (applicationId, minisites) => {

  return {
    type: FETCHCOUPONS_SUCCESS,
    applicationId: applicationId,
    payload: minisites
  };
};

export const fetchVotings = (applicationId) => {
  return {
    type: FETCHVOTINGS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchVotingsSuccess = (applicationId, minisites) => {

  return {
    type: FETCHVOTINGS_SUCCESS,
    applicationId: applicationId,
    payload: minisites
  };
};

export const fetchPollings = (applicationId) => {
  return {
    type: FETCHPOLLINGS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchPollingsSuccess = (applicationId, minisites) => {

  return {
    type: FETCHPOLLINGS_SUCCESS,
    applicationId: applicationId,
    payload: minisites
  };
};

export const fetchDeepLinks = (applicationId) => {
  return {
    type: FETCHDEEPLINKS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchDeepLinksSuccess = (applicationId, minisites) => {

  return {
    type: FETCHDEEPLINKS_SUCCESS,
    applicationId: applicationId,
    payload: minisites
  };
};

export const fetchAdvertisement = (minisiteId) => {
  console.log('minisiteId', minisiteId);
  return {
    type: FETCHADVERTISEMENT,
    payload: {
      minisiteId: minisiteId
    }
  };
};

export const fetchAdvertisementSuccess = (minisiteId, minisite) => {

  return {
    type: FETCHADVERTISEMENT_SUCCESS,
    minisiteId: minisiteId,
    payload: minisite
  };
};

export const fetchCoupon = (minisiteId) => {
  return {
    type: FETCHCOUPON,
    payload: {
      minisiteId: minisiteId
    }
  };
};

export const fetchCouponSuccess = (minisiteId, minisite) => {

  return {
    type: FETCHCOUPON_SUCCESS,
    minisiteId: minisiteId,
    payload: minisite
  };
};

export const fetchVoting = (minisiteId) => {
  return {
    type: FETCHVOTING,
    payload: {
      minisiteId: minisiteId
    }
  };
};

export const fetchVotingSuccess = (minisiteId, minisite) => {

  return {
    type: FETCHVOTING_SUCCESS,
    minisiteId: minisiteId,
    payload: minisite
  };
};

export const fetchPolling = (minisiteId) => {
  return {
    type: FETCHPOLLING,
    payload: {
      minisiteId: minisiteId
    }
  };
};

export const fetchPollingSuccess = (minisiteId, minisite) => {
  console.log('fetchPollingSuccess', minisiteId, minisite);

  return {
    type: FETCHPOLLING_SUCCESS,
    minisiteId: minisiteId,
    payload: minisite
  };
};

export const fetchDeepLink = (minisiteId) => {
  return {
    type: FETCHDEEPLINK,
    payload: {
      minisiteId: minisiteId
    }
  };
};

export const fetchDeepLinkSuccess = (minisiteId, minisite) => {
  console.log('fetchDeepLinkSuccess', minisiteId, minisite);

  return {
    type: FETCHDEEPLINK_SUCCESS,
    minisiteId: minisiteId,
    payload: minisite
  };
};

export const fetchEvents = (minisiteId) => {
  console.log('fetchEvents action', minisiteId);
  return {
    type: FETCHEVENTS,
    payload: {
      minisiteId: minisiteId
    }
  };
};

export const fetchEventsSuccess = (minisiteId, events) => {
  return {
    type: FETCHEVENTS_SUCCESS,
    minisiteId: minisiteId,
    payload: events
  };
};

export const createEvent = (creatingEvent) => {
  console.log('createEvent', creatingEvent);

  return {
    type: CREATEEVENT,
    payload: creatingEvent
  };
};

export const createEventSuccess = (createdEvent) => {

  return {
    type: CREATEEVENT_SUCCESS,
    payload: createdEvent
  };
};

export const updateEvent = (updatingEvent) => {

  return {
    type: UPDATEEVENT,
    payload: updatingEvent
  };
};

export const updateEventSuccess = (updatedEvent) => {
  return {
    type: UPDATEEVENT_SUCCESS,
    payload: updatedEvent
  };
};

export const deleteEvent = (deletingEvent) => {
  return {
    type: DELETEEVENT,
    payload: deletingEvent
  };
};

export const deleteEventSuccess = (deletedEvent) => {
  return {
    type: DELETEEVENT_SUCCESS,
    payload: deletedEvent
  };
};

export const fetchPollingQuestions = (minisiteId) => {
  console.log('fetchEvents action', minisiteId);
  return {
    type: FETCHPOLLINGQUESTIONS,
    payload: {
      polling: minisiteId
    }
  };
};

export const fetchPollingQuestionsSuccess = (minisiteId, pollingQuestions) => {
  console.log('fetchPollingQuestionsSuccess', pollingQuestions, minisiteId);
  return {
    type: FETCHPOLLINGQUESTIONS_SUCCESS,
    minisiteId: minisiteId,
    payload: pollingQuestions
  };
};

export const fetchVotingQuestions = (minisiteId) => {
  console.log('fetchEvents action', minisiteId);
  return {
    type: FETCHVOTINGQUESTIONS,
    payload: {
      voting: minisiteId
    }
  };
};

export const fetchVotingQuestionsSuccess = (minisiteId, votingQuestions) => {
  return {
    type: FETCHVOTINGQUESTIONS_SUCCESS,
    minisiteId: minisiteId,
    payload: votingQuestions
  };
};

export const fetchVotingAnswers = (votingQuestionId) => {
  return {
    type: FETCHVOTINGANSWERS,
    payload: {
      votingQuestionId: votingQuestionId
    }
  };
};

export const fetchVotingAnswersSuccess = (votingQuestionId, votingAnswers) => {
  return {
    type: FETCHVOTINGANSWERS_SUCCESS,
    votingQuestionId: votingQuestionId,
    payload: votingAnswers
  };
};

export const fetchPollingAnswers = (pollingQuestionId) => {
  console.log('fetchPollingAnswers', pollingQuestionId);
  return {
    type: FETCHPOLLINGANSWERS,
    payload: {
      pollingQuestionId: pollingQuestionId
    }
  };
};

export const fetchPollingAnswersSuccess = (pollingQuestionId, pollingAnswers) => {
  return {
    type: FETCHPOLLINGANSWERS_SUCCESS,
    pollingQuestionId: pollingQuestionId,
    payload: pollingAnswers
  };
};

export const createAdvertisement = (creatingMinisite) => {
  console.log('creatingAdvertisement', creatingMinisite);

  return {
    type: CREATEADVERTISEMENT,
    payload: creatingMinisite
  };
};

export const createAdvertisementSuccess = (createdMinisite) => {

  return {
    type: CREATEADVERTISEMENT_SUCCESS,
    payload: createdMinisite
  };
};

export const updateAdvertisement = (updatingMinisite) => {

  return {
    type: UPDATEADVERTISEMENT,
    payload: updatingMinisite
  };
};

export const updateAdvertisementSuccess = (updatedMinisite) => {
  return {
    type: UPDATEADVERTISEMENT_SUCCESS,
    payload: updatedMinisite
  };
};

export const deleteAdvertisement = (deletingMinisite) => {
  return {
    type: DELETEADVERTISEMENT,
    payload: deletingMinisite
  };
};

export const deleteAdvertisementSuccess = (deletedMinisite) => {
  return {
    type: DELETEADVERTISEMENT_SUCCESS,
    payload: deletedMinisite
  };
};


export const createCoupon = (creatingMinisite) => {
  console.log('creatingCoupon', creatingMinisite);

  return {
    type: CREATECOUPON,
    payload: creatingMinisite
  };
};

export const createCouponSuccess = (createdMinisite) => {

  return {
    type: CREATECOUPON_SUCCESS,
    payload: createdMinisite
  };
};

export const updateCoupon = (updatingMinisite) => {

  return {
    type: UPDATECOUPON,
    payload: updatingMinisite
  };
};

export const updateCouponSuccess = (updatedMinisite) => {
  return {
    type: UPDATECOUPON_SUCCESS,
    payload: updatedMinisite
  };
};

export const deleteCoupon = (deletingMinisite) => {
  return {
    type: DELETECOUPON,
    payload: deletingMinisite
  };
};

export const deleteCouponSuccess = (deletedMinisite) => {
  return {
    type: DELETECOUPON_SUCCESS,
    payload: deletedMinisite
  };
};

export const createVoting = (creatingMinisite) => {
  console.log('creatingVoting', creatingMinisite);

  return {
    type: CREATEVOTING,
    payload: creatingMinisite
  };
};

export const createVotingSuccess = (createdMinisite) => {

  return {
    type: CREATEVOTING_SUCCESS,
    payload: createdMinisite
  };
};

export const updateVoting = (updatingMinisite) => {

  return {
    type: UPDATEVOTING,
    payload: updatingMinisite
  };
};

export const updateVotingSuccess = (updatedMinisite) => {
  return {
    type: UPDATEVOTING_SUCCESS,
    payload: updatedMinisite
  };
};

export const deleteVoting = (deletingMinisite) => {
  return {
    type: DELETEVOTING,
    payload: deletingMinisite
  };
};

export const deleteVotingSuccess = (deletedMinisite) => {
  return {
    type: DELETEVOTING_SUCCESS,
    payload: deletedMinisite
  };
};

export const createPolling = (creatingMinisite) => {
  console.log('creatingPolling', creatingMinisite);

  return {
    type: CREATEPOLLING,
    payload: creatingMinisite
  };
};

export const createPollingSuccess = (createdMinisite) => {

  return {
    type: CREATEPOLLING_SUCCESS,
    payload: createdMinisite
  };
};

export const updatePolling = (updatingMinisite) => {

  return {
    type: UPDATEPOLLING,
    payload: updatingMinisite
  };
};

export const updatePollingSuccess = (updatedMinisite) => {
  return {
    type: UPDATEPOLLING_SUCCESS,
    payload: updatedMinisite
  };
};

export const deletePolling = (deletingMinisite) => {
  return {
    type: DELETEPOLLING,
    payload: deletingMinisite
  };
};

export const deletePollingSuccess = (deletedMinisite) => {
  return {
    type: DELETEPOLLING_SUCCESS,
    payload: deletedMinisite
  };
};

export const createDeepLink = (creatingMinisite) => {
  console.log('creatingDeepLink', creatingMinisite);

  return {
    type: CREATEDEEPLINK,
    payload: creatingMinisite
  };
};

export const createDeepLinkSuccess = (createdMinisite) => {

  return {
    type: CREATEDEEPLINK_SUCCESS,
    payload: createdMinisite
  };
};

export const updateDeepLink = (updatingMinisite) => {

  return {
    type: UPDATEDEEPLINK,
    payload: updatingMinisite
  };
};

export const updateDeepLinkSuccess = (updatedMinisite) => {
  return {
    type: UPDATEDEEPLINK_SUCCESS,
    payload: updatedMinisite
  };
};

export const deleteDeepLink = (deletingMinisite) => {
  return {
    type: DELETEDEEPLINK,
    payload: deletingMinisite
  };
};

export const deleteDeepLinkSuccess = (deletedMinisite) => {
  return {
    type: DELETEDEEPLINK_SUCCESS,
    payload: deletedMinisite
  };
};
